var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Box, Menu, MenuItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import ButtonWithIcon, { ButtonIconType, getIconByType } from './ButtonWithIcon';
import { pxToRem } from '../conversion';
var PopupMenu = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? ButtonIconType.moreVert : _b, _c = _a.items, items = _c === void 0 ? [] : _c;
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var onOpenMenu = useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = useCallback(function () {
        setAnchorEl(null);
    }, []);
    var mainButton = _jsx(ButtonWithIcon, { icon: icon, label: 'Menu', color: 'secondary', onClick: onOpenMenu });
    return (_jsxs(_Fragment, { children: [_jsx(Box, { children: mainButton }), _jsx(Menu, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleClose, sx: { filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))' } }, { children: items.map(function (item) {
                    if (!item)
                        return _jsx(_Fragment, {});
                    return (_jsxs(MenuItem, __assign({ "data-test_id": "menu_item_".concat(item.icon), onClick: function (e) {
                            item.onClick && item.onClick(e);
                            setAnchorEl(null);
                        } }, { children: [_jsx(ListItemIcon, __assign({ sx: { minWidth: pxToRem(30) } }, { children: getIconByType(item.icon, { color: item.color === undefined ? 'primary' : item.color }) })), _jsx(ListItemText, { children: _jsx(Typography, __assign({ sx: { textTransform: 'capitalize', fontSize: pxToRem(14), color: '#6e6e6e' } }, { children: item.text === undefined ? item.icon : item.text })) })] }), item.icon));
                }) }))] }));
};
export default PopupMenu;
